import React, { Component } from 'react';
import Link from 'react-router-dom/Link';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Button from 'react-bootstrap/lib/Button';
import AvatarWithNameAndBio from '../AvatarWithNameAndBio';
import LandingPageSection from '../LandingPageSection';
import MarketingAboutAnchor from '../MarketingAboutAnchor';
import Footer from '../Footer';
import OutboundLink from '../OutboundLink';
import MarketingFooter from '../MarketingFooter';
import {
  appStoreLink,
  playStoreLink,
  getOpenInAppUrl,
  isAndroidChrome,
} from '../../../helpers/serverRenderingUtils';
import styles from './styles.sass';

class EpisodeOld extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const {
      creator,
      location,
      title,
      volumeData,
      actions,
      stations,
    } = this.props;

    return (
      <div className="isV2LegacyPage">
        <div className={styles.headerBackdrop}>
          <div
            className={styles.stationBackdrop}
            style={{
              backgroundImage:
                'url(https://d12xoj7p9moygp.cloudfront.net/images/waveBackground.png)',
            }}
          >
            <div className={styles.station}>
              <Row className={styles.stationHeader}>
                <Col md={12}>{creatorOrNextStationCreator(creator || {})}</Col>
              </Row>
              <div className={styles.segment}>
                <h3>{title}</h3>
                {isAndroidChrome() ? (
                  <div>
                    <p>
                      We're currently beta testing Episodes in Anchor's iOS app
                      and plan to bring them to Android soon.
                    </p>
                    <p>Thanks for your patience!</p>
                    <OutboundLink
                      to="https://anch.co/get_anchor"
                      className="visible-xs-inline visible-sm-inline"
                    >
                      <Button className={styles.getTheApp}>Get the App</Button>
                    </OutboundLink>
                  </div>
                ) : (
                  <div>
                    <p>
                      You can listen to this episode for free in the Anchor app.
                    </p>
                    <OutboundLink
                      to="https://anch.co/get_anchor"
                      className="visible-xs-inline visible-sm-inline"
                    >
                      <Button className={styles.getTheApp}>Get the App</Button>
                    </OutboundLink>
                    <Link
                      to={getOpenInAppUrl(
                        `${location.pathname}${location.search}`
                      )}
                      className="visible-xs-inline visible-sm-inline"
                    >
                      <Button className={styles.openInApp}>Open in App</Button>
                    </Link>
                    <Row className="hidden-xs hidden-sm">
                      <Col md={6} className="text-right">
                        <OutboundLink to={appStoreLink()} newWindow>
                          <img
                            alt="App Store"
                            src="https://d12xoj7p9moygp.cloudfront.net/images/appstore-logo.png"
                            srcSet="https://d12xoj7p9moygp.cloudfront.net/images/appstore-logo.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/appstore-logo@2x.png 2x"
                            width={161}
                            height={48}
                          />
                        </OutboundLink>
                      </Col>
                      <Col md={6} className="text-left">
                        <OutboundLink to={playStoreLink()} newWindow>
                          <img
                            alt="Google Play Store"
                            src="https://d12xoj7p9moygp.cloudfront.net/images/playstore-logo.png"
                            srcSet="https://d12xoj7p9moygp.cloudfront.net/images/playstore-logo.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/playstore-logo@2x.png 2x"
                            width={164}
                            height={48}
                          />
                        </OutboundLink>
                      </Col>
                    </Row>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <LandingPageSection
          title="You’re listening to Anchor"
          subtitle="And here’s what that means:"
          headerBgColor="#8940FA"
          bgColor="#2EFFD9"
        >
          <MarketingAboutAnchor />
        </LandingPageSection>
        <Footer>
          <MarketingFooter />
        </Footer>
      </div>
    );
  }
}

export default EpisodeOld;

function creatorOrNextStationCreator({ name, bio, imageUrl, userId }) {
  return (
    <AvatarWithNameAndBio
      name={name}
      bio={bio}
      imageUrl={imageUrl}
      userId={userId}
    />
  );
}
